import Service from "../Service";
const resource = "TasProducerContract/";
import Vue from "vue";


export default {
    save(cmp, requestID) {
        return Service.post(resource + "saveAddenda", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "paginationAddenda", parameters, {
            params: { requestID: requestID },
        });
    },


};